import { InputHTMLAttributes } from "react";
type Props = InputHTMLAttributes<HTMLInputElement> & { label?: string };
export default function Input({ label, ...rest }: Props){
  return (
    <div>
      {label && <label>{label}</label>}
      <input {...rest} />
    </div>
  );
}
